import {Vue, Component, Prop} from 'vue-property-decorator';

import * as tsx from 'vue-tsx-support';
import timestampToDate from '@/utils/timestampToDate';
import {justifyContent} from '@/components/Device';
import Log from '@/components/Log';

import './style.less';

const texts = [
  '',
  '（到期后数据将被清除，请您提前续费）',
  '（立即续费可保留手机数据）'
]

interface IMask {
  time?: number;
  events?: object;
  data?: object;
  type?: justifyContent;
}

@Component
export default class DeviceMask extends tsx.Component<IMask> {
  
  @Prop({default: 0}) public time?: number
  @Prop() public events?: object
  @Prop() public data?: object;
  @Prop() public type?: justifyContent
  
  state = {
    time: 0,
    type: 0 // 0 不展示 1 小于一天 2 小于半小时
  }
  
  mounted () {
    this.state.time = this.$props.time
    if (this.state.time <= 86400) {
      this.state.type = 1
    }
  
    if (this.state.time <= 0) {
      this.state.type = 2
    }
    
  const setIntervalTime =  setInterval(() => {
      if (this.state.time <= 86400) {
        this.state.type = 1
      }
      if (this.state.time <= 0) {
        this.state.type = 2
        clearInterval(setIntervalTime)
        return false
      }
      this.state.time = this.state.time - 60
    }, 1000 * 60)
  }
  
  getFontClassName () {
    if (this.$props.type === justifyContent.center) {
      return 'mask-container-text-time'
    }
    return 'mask-container-text-time-s'
  }
  
  render() {
    const {events, data} = this.$props;
    return this.state.type !== 0 ? (
      <div class='mask-container'>
        <Log type='hooks' number='H023' />
        <div class='mask-container-text'>
          <div class='mask-container-text-title'>剩余时间</div>
          <div class={`${this.getFontClassName()} ${this.state.type === 2 && 'mask-title-color'}`}>{timestampToDate(data.remainTime)}</div>
          <div class='mask-container-text-time-describe'>{texts[this.state.type]}</div>
        </div>
        <div class='mask-container-button-list'>
          <Log number='H005'>
            <div onClick={() => events.cloudDevicePlay(data.id)} class={`mask-container-button mask-container-button-defaule ${this.state.type === 2 && 'mask-button-hide'}`}>继续游戏</div>
          </Log>
          <Log number='H028'>
            <div onClick={() => events.routerPushPackage(data)} class='mask-container-button'>立即续费</div>
          </Log>
        </div>
      </div>
    ) : null
  }
  
}